import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// PUBLIC
import CorporateHomePage from "./pages/Dynamic/CorporateHomePage/CorporateHomePage";

// ADMIN
import Dashboard from "./pages/Dashboard";
import KategoriPage from "./pages/Admin/KategoriPage/KategoriPage";
import UrunlerPage from "./pages/Admin/Urunler/UrunlerPage";
import HomeConfigPage from "./pages/Admin/AdminHomeDataPage/AdminHomeDataPage";
import AdminLoginPage from "./pages/Admin/AdminLoginPage";
import { AdminAuthProvider } from "./context/AdminAuthContext";
import PublicLayout from "./pages/Layouts/HomePage/PublicLayout";
import RequireAdmin from "./pages/Admin/RequireAdmin";
import AdminShell from "./pages/Admin/AdminShell";
import { ThemeProvider } from "./context/ThemeContext";
import ProjelerPage from "./pages/Layouts/ProjelerPage/ProjelerPage";
import IletisimPage from "./pages/Layouts/IletisimPage/IletisimPage";
import CategoryPage from "./pages/Layouts/CategoryPage/CategoryPage";
import ProductDetail from "./pages/Layouts/Products/ProductDetail/ProductDetail";
import Products from "./pages/Layouts/Products/Products";
import AdminProjelerPage from "./pages/Admin/AdminProjelerPage/AdminProjelerPage";
import ProjeDetayPage from "./pages/Layouts/ProjelerPage/ProjeDetayPage/ProjeDetayPage";

// ✅ MÜŞTERİ
import LoginPage from "./pages/Customer/LoginPage/LoginPage";
import RegisterPage from "./pages/Customer/RegisterPage/RegisterPage";
import RequireCustomer from "./pages/Customer/RequireCustomer/RequireCustomer";
import CustomerShell from "./pages/Customer/CustomerShell/CustomerShell";
import PanelOverview from "./pages/Customer/PanelOverview/PanelOverview";
import AddressesPage from "./pages/Customer/AddressesPage/AddressesPage";
import ProfilePage from "./pages/Customer/ProfilePage/ProfilePage";
import { CustomerAuthProvider } from "./context/CustomerAuthContext/CustomerAuthContext";
import { CartProvider } from "./context/CartContext/CartContext";
import CartPage from "./pages/Customer/CartPage/CartPage";
import OrdersPage from "./pages/Customer/OrdersPage/OrdersPage";
import OrderDetailPage from "./pages/Customer/OrdersPage/OrderDetailPage";
import CheckoutPage from "./pages/Customer/CheckoutPage/CheckoutPage";
import CheckoutSuccess from "./pages/Customer/CheckoutPage/CheckoutSuccess";
import SifrePage from "./pages/Customer/SifrePage/SifrePage";
import SiparislerPage from "./pages/Admin/AdminSiparislerPage/AdminSiparislerPage";
import AdminYorumlarPage from "./pages/Admin/AdminYorumlarPage/AdminYorumlarPage";
import FavoritesPage from "./pages/Customer/FavoritesPage/FavoritesPage";
import { FavoriteProvider } from "./context/FavoriteContext/FavoriteContext";

// ✅ PAYTR iFrame sayfası
import PaytrPage from "./pages/Customer/PaytrPage/PaytrPage"; // <— ekledik
import MesafeliSatisSozlesmesi from "./pages/Layouts/MesafeliSatisSozlesmesi/MesafeliSatisSozlesmesi";
import TeslimatDegisimIadeKosullari from "./pages/Layouts/TeslimatDegisimIadeKosullari/TeslimatDegisimIadeKosullari";
import GizlilikPolitikasi from "./pages/Layouts/GizlilikPolitikasi/GizlilikPolitikasi";
import KullaniciSozlesmesi from "./pages/Layouts/KullaniciSozlesmesi/KullaniciSozlesmesi";

// Basit “ödeme hata” sayfası (dilersen ayrı dosya yap)
const PaymentFailPage = () => (
  <div className="max-w-xl mx-auto p-8">
    <div className="rounded-lg border p-6" style={{ borderColor: "rgba(239,68,68,.4)", background: "rgba(239,68,68,.08)" }}>
      <div className="text-lg font-semibold mb-2" style={{ color: "#b91c1c" }}>Ödeme başarısız</div>
      <p className="text-sm mb-4">İşleminiz tamamlanamadı. Tekrar deneyebilir veya farklı bir ödeme yöntemi seçebilirsiniz.</p>
      <a className="underline" href="/musteri/checkout">Ödeme adımına geri dön</a>
    </div>
  </div>
);

const NotFound = () => <div className="p-10 text-center">404 - Sayfa bulunamadı</div>;

const App = () => (
  <BrowserRouter>
    {/* Sarmalama sırası: Router > (Opsiyonel) Theme > AdminAuth > CustomerAuth > Routes */}
    <ThemeProvider>
      <AdminAuthProvider>
        <CustomerAuthProvider>
          <CartProvider>
            <FavoriteProvider>

            <Routes>
              {/* PUBLIC (HeaderPublic bu layout içinde) */}
              <Route element={<PublicLayout />}>
                <Route index element={<CorporateHomePage />} />
                <Route path="products" element={<Products />} />
                <Route path="mesafelisatissozlesmesi" element={<MesafeliSatisSozlesmesi />} />
                <Route path="teslimatdegisimiadekosullari" element={<TeslimatDegisimIadeKosullari />} />
                <Route path="gizlilikpolitikasi" element={<GizlilikPolitikasi />} />
                <Route path="kullanicisozlesmesi" element={<KullaniciSozlesmesi />} />

                <Route path="projeler" element={<ProjelerPage />} />
                <Route path="projeler/:id" element={<ProjeDetayPage />} />
                <Route path="iletisim" element={<IletisimPage />} />
                <Route path="kategori/:slug" element={<CategoryPage />} />
                <Route path="urun/:id" element={<ProductDetail />} />

                {/* Müşteri - public altı (relative path KULLANILDI) */}
                <Route path="musteri/giris" element={<LoginPage />} />
                <Route path="musteri/kayit" element={<RegisterPage />} />

                {/* Checkout (korumalı) */}
                <Route
                  path="musteri/checkout"
                  element={
                    <RequireCustomer>
                      <CheckoutPage />
                    </RequireCustomer>
                  }
                />
                <Route
                  path="musteri/checkout/basarili"
                  element={
                    <RequireCustomer>
                      <CheckoutSuccess />
                    </RequireCustomer>
                  }
                />

                {/* PAYTR iFrame & sonuç sayfaları (korumalı) */}
                <Route
                  path="musteri/odeme/paytr"
                  element={
                    <RequireCustomer>
                      <PaytrPage />
                    </RequireCustomer>
                  }
                />
                <Route
                  path="musteri/odeme/basarili"
                  element={
                    <RequireCustomer>
                      {/* İstersen burada da CheckoutSuccess'i kullan */}
                      <CheckoutSuccess />
                    </RequireCustomer>
                  }
                />
                <Route
                  path="musteri/odeme/hata"
                  element={
                    <RequireCustomer>
                      <PaymentFailPage />
                    </RequireCustomer>
                  }
                />

                {/* MÜŞTERİ PANEL (korumalı) */}
                <Route
                  path="musteri/panel"
                  element={
                    <RequireCustomer>
                      <CustomerShell />
                    </RequireCustomer>
                  }
                >
                  <Route index element={<PanelOverview />} />
                  <Route path="siparisler" element={<OrdersPage />} />
                  <Route path="siparisler/:id" element={<OrderDetailPage />} />
                  <Route path="adresler" element={<AddressesPage />} />
                  <Route path="profil" element={<ProfilePage />} />
                  <Route path="sifre" element={<SifrePage />} />
                  <Route path="favoriler" element={<FavoritesPage />} />
                  {/* <Route path="sepet" element={<CartPage />} /> */}
                </Route>
              </Route>

              {/* Admin login (korumasız) */}
              <Route path="/admin/login" element={<AdminLoginPage />} />

              {/* Admin (korumalı) */}
              <Route
                path="/admin"
                element={
                  <RequireAdmin>
                    <AdminShell />
                  </RequireAdmin>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="kategoriler" element={<KategoriPage />} />
                <Route path="urunler" element={<UrunlerPage />} />
                <Route path="anaekran" element={<HomeConfigPage />} />
                <Route path="adminprojeler" element={<AdminProjelerPage />} />
                <Route path="adminsiparisler" element={<SiparislerPage />} />
                <Route path="yorumlar" element={<AdminYorumlarPage />} />
              </Route>

              {/* Eski kısa yollar (opsiyonel) */}
              <Route path="/kategoriler" element={<Navigate to="/admin/kategoriler" replace />} />
              <Route path="/urunler" element={<Navigate to="/admin/urunler" replace />} />
              <Route path="/anaekranadmin" element={<Navigate to="/admin/anaekran" replace />} />
              <Route path="/adminprojeler" element={<Navigate to="/admin/adminprojeler" replace />} />
              <Route path="/adminsiparisler" element={<Navigate to="/admin/adminsiparisler" replace />} />

              {/* 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>

            </FavoriteProvider>
          </CartProvider>
        </CustomerAuthProvider>
      </AdminAuthProvider>
    </ThemeProvider>
  </BrowserRouter>
);

export default App;
